import { Box, styled } from "@mui/material";

export const StyledPopover = styled(Box)(({ theme: { spacing, palette } }) => ({
  width: 260,
  padding: spacing(2),
  background: palette.main[900],

  "& .MuiButton-root": {
    justifyContent: "start",
    background: "transparent",

    "&:hover": {
      background: palette.main[800],
    },
  },
}));
